import { render, staticRenderFns } from "./queSomos.vue?vue&type=template&id=9da1555a&scoped=true"
import script from "./queSomos.vue?vue&type=script&lang=js"
export * from "./queSomos.vue?vue&type=script&lang=js"
import style0 from "./queSomos.vue?vue&type=style&index=0&id=9da1555a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da1555a",
  null
  
)

export default component.exports